// extracted by mini-css-extract-plugin
export default {"postImg":"styles_postImg__uAfER","blurFilterImg":"styles_blurFilterImg__H4JQY"};